import "./Roulette.css";

import { motion, useAnimationControls, animate, useMotionValue, motionValue, useTransform, } from "framer-motion";
import { useEffect, useState, useContext, } from "react";
import axios from "axios";
import CookieContext from "../../contexts/CookieContext";
import AppContext from "../../contexts/AppContext";
import useSound from "use-sound";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';

import soundInRaffle from '../../library/sounds/inRaffle.mp3';
import soundStop from '../../library/sounds/stop.mp3';

import styled from "@emotion/styled";

const StyledButton = styled.button`
  width: 150px;
  color: ${({ disabled }) => disabled ? '#ffffff' : '#cccccc'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #000099)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 0px;`}
`;

const RetrieveButton = styled.button`
  width: 150px;
  color: ${({ disabled }) => disabled ? '#ffffff' : '#ffffff'};
  background: ${
    /* disableを第一優先、activeを第二優先にして背景色を設定 */
    ({ disabled }) => disabled
      ? 'linear-gradient(180deg, #666666, #999999)'
      : ({ active }) => active
        ? 'linear-gradient(180deg, #663300, #996633)'
        : 'linear-gradient(180deg, #100c08, #663300)'
  };
  /* ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`} */
  &:hover {
    color: #ff007f;
    box-shadow: rgb(255, 0, 127) 3px 3px 0px;
  }
`;

const RouletteType05 = () => {
  const [playSoundInRaffle] = useSound(soundInRaffle);
  const [playSoundStop] = useSound(soundStop);

  // 抽選数字
  const [ selectedNumber, setSelectedNumber ] = useState(0);

  // 抽選アイテム
  const [roulettes, setRoulettes] = useState([]);
  const [rouletteId, setRouletteId] = useState();
  const [rouletteItems, setRouletteItems] = useState(['']);

  // 抽選中数字（小数点以下あり）
  const [ motionValueInRaffleNumber, setMotionValueInRaffleNumber ] = useState(useMotionValue(0));
  // 抽選中数字（小数点以下切り上げ）
  // const [ inRaffleNumber, setInRaffleNumber ] = useState(useTransform(motionValueInRaffleNumber, Math.ceil));

  // 表示ナンバー
  const [ displayNumber, setDisplayNumber ] = useState(1);

  const [ retrieveButtonDisabled, setRetrieveButtonDisabled ] = useState(false);
  const [ executeButtonDisabled, setExecuteButtonDisabled ] = useState(true);

  const { cookies, setCookie } = useContext(CookieContext);
  const { apiHost } = useContext(AppContext);
  const basePath = 'roulette/';

  const [loadingRoulettes, setLoadingRoulettes] = useState(true);
  const [loadingRouletteItems, setLoadingRouletteItems] = useState(false);

  const [error, setError] = useState();
  const [active, setActive] = useState(roulettes[0]);
  const [debugMessage, setDebugMessage] = useState('');


  // ルーレット回転数（現在の数値より大きい数値になることを担保するために2以上の値を設定）
  let rouletteRoundCounter = 2;
  // 止まるまでの時間
  let initDuration = 3;

  const [duration, setDuration] = useState(initDuration);

  // 抽選数字の最大値
  let maxNumber = rouletteItems.length;

  // min, max間の整数を均等な期待値でランダムに抽出
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const loggingRouletteHistory = async() => {

    // ルーレットスタート時に履歴作成
    try {
      // jwtがある場合、headers（認証情報）有り
      var postData = {
        process: 'start_from',
        number: displayNumber,
        max_number: maxNumber,
        item_title: rouletteItems[displayNumber - 1].title,
        item_content: "結果内容",
      }

      // const response = await axios.post(`${apiHost}${basePath}noauth/1/histories`, postData, );
      const response = await axios.post(`${apiHost}${basePath}/${rouletteId}/histories`, postData, );
      // post成功時、status201
      if (response.status === 201) {
        // handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
      } else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleRouletteStart = async() => {

    // ルーレット開始時にボタンを押せないようにし、停止時の音を鳴らす設定に更新
    // setRetrieveButtonDisabled(true);
    // setExecuteButtonDisabled(true);
    setDuration(initDuration);

    // 動作中数値確認用メッセージをスタート時にクリア
    setDebugMessage('');

    // スタート位置設定（前回止まった位置をスタート位置とする）
    await motionValueInRaffleNumber.set(selectedNumber % maxNumber);

    // ルーレット選択直後は前回の結果がなく、スタート時に1から2へ動く挙動をさせるために1を設定する
    if (selectedNumber === 0){
      setSelectedNumber(1);
      motionValueInRaffleNumber.set(1);
    }
    
    // アイテム数×回転数+1～アイテム数×（回転数+1）の数字をランダムでget
    // 例：10アイテム、2回転の場合、21～30から抽選、3アイテム、4回転の場合、13～15から抽選
    const reactSelectedNumber = randomNumberInRange(maxNumber * rouletteRoundCounter + 1, maxNumber * (rouletteRoundCounter + 1));
    await setSelectedNumber(reactSelectedNumber);

    // ルーレット停止時に履歴作成
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await axios.post(`${apiHost}${basePath}record/${rouletteId}/`, 
          {
            'selectedNumber': reactSelectedNumber,
            'selectedItemNumber': ((reactSelectedNumber % maxNumber) === 0) ? (maxNumber) : (reactSelectedNumber % maxNumber),
            'selectedItem': Array.isArray(rouletteItems) ? rouletteItems[(((reactSelectedNumber % maxNumber) === 0) ? (maxNumber) : (reactSelectedNumber % maxNumber)) - 1].name : '---',
          },
          {headers},
        );
        // post成功時、status201
        if (response.status === 201) {
          // handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
        } else {
          setError('エラー');
        }
      }
    } catch (err) {
      console.log(err);
    }

    // loggingRouletteHistory();
  }

  // motionValueの値の整数部分が変わったかをチェック
  const motionValueInRuffleNumberCheck = async () => {

    // 数値の一の位が前回の値と変わったら
    if (Math.ceil(motionValueInRaffleNumber.prev) < Math.ceil(motionValueInRaffleNumber.current)){

      // アイテム数+1の剰余を設定（例：アイテム数10場合、0～9ではなく、1～10の値を取得する）
      await setDisplayNumber(((Math.ceil(motionValueInRaffleNumber.current) - 1) % maxNumber) + 1);

      // デバッグ用コンソールログ
      console.log(
        'motionValueInRaffleNumber:', motionValueInRaffleNumber, 
        'displayNumber:', displayNumber,
      );

      // 画面用メッセージ
      setDebugMessage(prevMessage => prevMessage + '■' + parseInt(Math.floor(motionValueInRaffleNumber.current) + 1))

      if (Math.ceil(motionValueInRaffleNumber.current) !== selectedNumber) {

        // 抽選数字でなければ、抽選中音を鳴らす
        await playSoundInRaffle();

      } else if (Math.ceil(motionValueInRaffleNumber.current) === selectedNumber){

        setDuration(0);
        // 抽選数字なら停止音を鳴らす
        await playSoundStop();

        // 画面用メッセージの最後に抽選結果を付与
        setDebugMessage(prevMessage => prevMessage + '【' + (Array.isArray(rouletteItems) ? rouletteItems[(((selectedNumber % maxNumber) === 0) ? (maxNumber) : (selectedNumber % maxNumber)) - 1].name : '---') + '】')

        // // ルーレット停止時に履歴作成
        // try {
        //   // jwtがある場合、headers（認証情報）有り
        //   var postData = {
        //     process: 'stop_at',
        //     number: displayNumber,
        //     max_number: maxNumber,
        //     item_title: rouletteItems[displayNumber - 1].title,
        //     item_content: "結果内容",
        //   }

        //   const response = await axios.post(`${apiHost}${basePath}no1/${rouletteId}/histories`, postData, );
        //   // post成功時、status201
        //   if (response.status === 201) {
        //     // handleAlertOpen(response.data.id, 'データ追加', 'データ追加が完了しました');
        //   } else {
        //     setError('エラー');
        //   }
        // } catch (err) {
        //   console.log(err);
        // }

        // 抽選が終ったため、ボタンを有効にする
        setRetrieveButtonDisabled(false);
        setExecuteButtonDisabled(false);
      }
    }
  }

  const handleRouletteStop = async() => {
    setDuration(0);
  }


  animate(motionValueInRaffleNumber, selectedNumber, {
    duration: duration,
    onUpdate: latest => [
      // デバッグ用コンソールログ
      // console.log(
      //   'motionValueInRaffleNumber:', motionValueInRaffleNumber, 
      //   'inRaffleNumber:', inRaffleNumber,
      //   'displayNumber:', displayNumber,
      //   'inRaffleNumber:', inRaffleNumber.get(),
      //   'latest:', latest
      // ),
      motionValueInRuffleNumberCheck(),
    ]
  });

  // データ更新用
  useEffect(() => {
    fetchRoulettes();
  }, []);


  const fetchRoulettes = async () => {
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(apiHost + basePath, {headers});

        if (response.status === 200) {
          // resetData();
          const data = await response.json();
          setRoulettes(data);

        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
    finally {
      setLoadingRoulettes(false);
    }
  }

  const retrieveRoulette = async(pk) => {
    // ルーレットデータ取得中は他のルーレットデータ取得と抽選は利用不可
    setRetrieveButtonDisabled(true);
    setExecuteButtonDisabled(true);

    setRouletteId(pk);
    setActive(pk);

    // ルーレットを変更した時はルーレット選択数字をリセットする
    setSelectedNumber(0);
    setDisplayNumber(1);

    setLoadingRouletteItems(true);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(`${apiHost}${basePath}${pk}/item/`, {headers});

        if (response.status === 200) {
          // resetData();
          const data = await response.json();
          await setRouletteItems(data);
          await setExecuteButtonDisabled(false);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
    finally {
      setLoadingRouletteItems(false);
      setRetrieveButtonDisabled(false);
      setExecuteButtonDisabled(false);
    }
  }

  return (
    <>
      <div style={{display: 'flex', flexWrap: 'wrap', border: '10px', padding: '10px', margin: '0 auto', width: 500,
        background: 'linear-gradient(180deg, #000000, #000000)', border: '1px solid #cccccc', color: '#cccccc',
        // fontSize: fontSize + 'rem',
        fontFamily: '"Noto Sans Math", sans-serif', fontWeight: 500, textAlign: 'left' }}>
        <div style={{width: '100%', border: '5px solid #cccccc', color: '#cccccc', margin: '10px', padding: '10px', textAlign: 'center', }}>ルーレット</div>

        <div style={{padding: '10px', margin: '0 auto', width: '330px',
        background: 'linear-gradient(180deg, #000000, #000000', border: '1px solid #cccccc', color: '#cccccc',
        fontFamily: '"Noto Sans Math", sans-serif', fontWeight: 500, textAlign: 'left' }}>

        {/* タイトル */}
        <div style={{textAlign: 'center'}}>
          ルーレット一覧
        </div>
        {/* ルーレット一覧を読込中 */}
        { loadingRoulettes ? (
          <>
            <div style={{textAlign: 'center'}}>
              Loading...
              <LinearProgress />
            </div>
          </>
        // ) : executeButtonDisabled ? (
        ) : retrieveButtonDisabled ? (
          <>
            <div style={{textAlign: 'center'}}>
              抽選中
              <LinearProgress />
            </div>
          </>
        ) : (
          <>
            <div style={{textAlign: 'center'}}>
              準備完了
            </div>
          </>
        )}

        {/* 抽選中かどうかにかかわらず、ボタンは表示させる */}
        {Array.isArray(roulettes) ? roulettes.map((roulette, index) => {
          return <RetrieveButton disabled={retrieveButtonDisabled} key={index} active={active === index + 1 ? +true : +false} onClick={() => {retrieveRoulette(roulette.uuid);}}>【{index + 1}】{roulette.name}</RetrieveButton>
        })
          : null
        }
      </div>


        <div style={{width: '100%', margin: '10px', padding: '10px', }}>

          { loadingRouletteItems ? (
          // {(loadingRoulettes || loadingRouletteItems) ? (
            <>
              <div>
                <LinearProgress />Loading...
              </div>
            </>
          ) : (
            <>
              {Array.isArray(rouletteItems) ? rouletteItems.map((rouletteItem, index) => {
                if(index < rouletteItems.length) {
                  // 一致している項目は、緑か黄色で表示
                  if(index + 1 === displayNumber){
                    // 停止数字だった場合は緑、そうでなければ黄色
                    if(selectedNumber === Math.ceil(motionValueInRaffleNumber.current)) {
                      return (<div key={index + 1} style={{ width: 400 +'px', background: 'linear-gradient(180deg, #9fc1ff, #dd97fd)', color: '#000000', }}>{index + 1}:{rouletteItem.name}</div>);
                    } else {
                      return (<div key={index + 1} style={{ width: 400 + 'px', background: 'linear-gradient(180deg, #f5ef98, #a5fcb7)', color: '#000000', }}>{index + 1}:{rouletteItem.name}</div>);
                    }
                  } else {
                    return (<div key={index + 1} style={{ width: 400 + 'px', }}>{index + 1}:{rouletteItem.name}</div>);
                  }
                }
              })
                : <div>下のルーレットを選択してください</div>
              }
            </>
          )}
        </div>

        <div style={{width: '100%', padding: '10px'}}>
          <StyledButton disabled={executeButtonDisabled} id='buttonRouletteStart' onClick={() => handleRouletteStart()}>
            抽選
          </StyledButton>
          <StyledButton id='buttonRouletteStop' onClick={() => handleRouletteStop()}>
            結果をすぐに表示
          </StyledButton>
        </div>
      </div>

      <div className="bd-callout bd-callout-warning" style={{ margin: "5px" }}>
        <Box>
          <Grid container spacing={2}>
            <Grid size={3}>selectedNumber</Grid>
            <Grid size={3}>selectedItemNumber</Grid>
            <Grid size={6}>selectedItem</Grid>
            <Grid size={3}>{selectedNumber}</Grid>
            <Grid size={3}>{((selectedNumber % maxNumber) === 0) ? (maxNumber) : (selectedNumber % maxNumber)}</Grid>
            <Grid size={6}>{Array.isArray(rouletteItems) ? rouletteItems[(((selectedNumber % maxNumber) === 0) ? (maxNumber) : (selectedNumber % maxNumber)) - 1].name : '---'}</Grid>

            <Grid size={3}>motionValueInRaffleNumber.current</Grid>
            <Grid size={3}>displayNumber</Grid>
            <Grid size={6}>selectedItem</Grid>
            <Grid size={3}>{Math.ceil(motionValueInRaffleNumber.current)}({Math.floor(motionValueInRaffleNumber.current * 1000) / 1000})</Grid>
            <Grid size={3}>{displayNumber}</Grid>
            <Grid size={6}>{Array.isArray(rouletteItems) ? rouletteItems[displayNumber - 1].name : '---'}</Grid>

            <Grid size={3}>motionValueInRaffleNumber.prev</Grid>
            <Grid size={3}>motionValueInRaffleNumber.updatedAt</Grid>
            <Grid size={3}>motionValueInRaffleNumber.prevUpdatedAt</Grid>
            <Grid size={3}>motionValueInRaffleNumber.get()</Grid>
            <Grid size={3}>{Math.ceil(motionValueInRaffleNumber.prev)}({Math.floor(motionValueInRaffleNumber.prev * 1000) / 1000})</Grid>
            <Grid size={3}>{Math.floor(motionValueInRaffleNumber.updatedAt)}</Grid>
            <Grid size={3}>{Math.floor(motionValueInRaffleNumber.prevUpdatedAt)}</Grid>
            <Grid size={3}>{motionValueInRaffleNumber.get()}</Grid>
          </Grid>
        </Box>
      </div>
      <div>
        {debugMessage}
      </div>
    </>
  )
}
export default RouletteType05
